
import React from "react";
import l from "components/util/l";

const ChatSuggestions = ({
  suggestions,
  currentMessage,
  suggestionTotalPages,
  onClickSuggestion,
  onClickMoreSuggestions
}) =>
  <div className="message-suggestions">
    <div className="d-flex flex-column justify-content-start ml-0 mt-2">
      {
        suggestions.map((s, index) => {
          const messageContent = s.suggestion.content;
          return (
            <div
              key={index}
              className={`d-flex flex-column align-items-start`}
            >
              <div
                role="button"
                onClick={() => onClickSuggestion(currentMessage, s)}
                className="message suggestion d-flex flex-row align-items-center"
              >
                <i className={function () {
                  let icon = "fas fa-diagram-project"
                  if (s.type == "NODE" || s.type == "WIZARD")
                    icon =  s.suggestion.action.node?.root_settings?.icon ?? 
                        (s.suggestion.action.node?.action?.type != "TRIGGER" ? "fas fa-diagram-project" : "fas fa-clock")
                  return icon;
                }()} />
                <div
                  dangerouslySetInnerHTML={{
                    __html: messageContent.text
                  }}
                />
              </div>
            </div>
          );
        })
      }

      {
        suggestionTotalPages > 1 &&
        <div
          className={
            `d-flex flex-column mb-1 mt-n1
            align-items-start animate__animated animate__fadeIn animate__faster`
          }>
          <div
            className="more-options-btn"
            onClick={() => onClickMoreSuggestions()}
          >
             <a className="fas fa-ellipsis-h mr-2"></a>{l('Más opciones%PA010')}
          </div>
        </div>
      }

    </div>
  </div>

export default ChatSuggestions;